//IMPORTING COLORS
import { useEffect, useState } from "react";
import authService from "../../services/authService";
import obituaryService from "../../services/obituaryService";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { LiaDoveSolid } from "react-icons/lia";
import Button from "react-bootstrap/Button";
import { FaRegStar } from "react-icons/fa";
import { TbBuildingBank } from "react-icons/tb";
import { PiFlowerTulipThin } from "react-icons/pi";
import { PiHandsPraying } from "react-icons/pi";
import CandleModal from "../CandleModal";
import "./ObituaryOverview.css";

export default function ObituaryOverview(props) {
  const [modalShow, setModalShow] = useState(false);
  const [obituaryData, setObituaryData] = useState();
  const [obituaryStatus, setObituaryStatus] = useState(false);
  const [falecidoName, setFalecidoName] = useState(null);

  function parseDatePtBR(dateString) {
    const parts = dateString.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }

  useEffect(() => {
    const startDay = new Date();
    startDay.setDate(startDay.getDate() - 15);
    const currentStartDay = startDay.toJSON().slice(0, 10);

    const endDay = new Date();
    const currentEndDay = endDay.toJSON().slice(0, 10);

    const fetchData = async () => {
      const tokenData = {
        NomeUsuario: process.env.REACT_APP_INVITA_API_USER,
        Senha: process.env.REACT_APP_INVITA_API_PASS,
      };

      authService
        .post(process.env.REACT_APP_INVITA_API_URL, tokenData)
        .then((response) => {
          const token = response.data;
          obituaryService
            .get(`/?dataInicio=${currentStartDay}&dataFim=${currentEndDay}`, {
              headers: {
                Authorization: `Bearer ${token.token}`,
              },
            })
            .then((response) => {
              setObituaryData(
                response.data.sort((a, b) => {
                  return (
                    parseDatePtBR(a.sepultamentoData) -
                    parseDatePtBR(b.sepultamentoData)
                  );
                }),
              );

              setObituaryStatus(true);
            })
            .catch((err) => {
              console.error("Ocorreu um erro na API Funeral Invita" + err);
            });
        })
        .catch((err) => {
          console.error("Ocorreu um erro " + err);
        });
    };
    fetchData();
  }, []);

  return (
    <Container fluid className="obituary-bg">
      <Container fluid className="obituary-overlay">
        <Container>
          <Row>
            <Col className="obituary-first-col">
              <div className="obituary-overview-icon" />
              <h2
                style={{ color: props.titleColor, fontSize: props.titleSize }}
              >
                OBITUÁRIO QUINZENAL
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="obituary-second-col">
              <p style={{ color: props.textColor, fontSize: props.textSize }}>
                Compartilhamos, com respeito e sensibilidade, as homenagens às
                pessoas que partiram nesta quinzena. <br />
                Que suas histórias e legados sigam iluminando aqueles que as
                amaram.
              </p>
            </Col>
          </Row>
        </Container>
        <Container className="obituary-overview-container">
          <Row>
            <Col
              lg="4"
              className="obituary-overview-label"
              style={{
                color: props.textColor,
                fontSize: props.subTextSize,
              }}
            >
              Falecido (a)
            </Col>
            <Col
              className="obituary-overview-label"
              style={{
                color: props.textColor,
                fontSize: props.subTextSize,
              }}
            >
              Nascimento
            </Col>
            <Col
              className="obituary-overview-label"
              style={{
                color: props.textColor,
                fontSize: props.subTextSize,
              }}
            >
              Falecimento
            </Col>
            <Col
              className="obituary-overview-label"
              style={{
                color: props.textColor,
                fontSize: props.subTextSize,
              }}
            >
              Local de Sepultamento
            </Col>
            <Col
              className="obituary-overview-label"
              style={{
                color: props.textColor,
                fontSize: props.subTextSize,
              }}
            >
              Vela Virtual
            </Col>
          </Row>
          {obituaryStatus ? (
            <div>
              {obituaryData.map((funeral, id) =>
                (funeral.divulgarRedeSocial === true &&
                  funeral.localVelorios.length > 0) ||
                funeral.localExternos.length > 0 ? (
                  <Row key={id} className="obituary-overview-card">
                    <Col sm="1" xs="2" className="obituary-overview-pic-col">
                      {funeral.fotoFalecido ? (
                        <img
                          src={
                            "data:image/jpeg;base64," +
                            funeral.fotoFalecido.content
                          }
                          alt="Foto do Falecido(a)"
                          className="obituary-overview-img"
                        />
                      ) : (
                        <div className="obituary-overview-no-img">
                          <PiFlowerTulipThin className="obituary-overview-no-img-icon" />
                        </div>
                      )}
                    </Col>
                    <Col sm="11" xs="10" className="align-self-center">
                      <Row>
                        <Col
                          md="4"
                          sm="4"
                          xs="12"
                          className="obituary-overview-name-col"
                        >
                          <h3
                            style={{
                              color: props.titleColor,
                              fontSize: props.textSize,
                            }}
                          >
                            {funeral.falecidoNome.toUpperCase()}
                          </h3>
                        </Col>
                        <Col sm="2" xs="4" className="obituary-overview-col">
                          <h4
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <FaRegStar
                              style={{ color: props.iconColor }}
                              className="obituary-overview-card-icon"
                            />
                            {funeral.falecidoDataNascimento}
                          </h4>
                        </Col>
                        <Col sm="2" xs="4" className="obituary-overview-col">
                          <h4
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <LiaDoveSolid
                              style={{ color: props.iconColor }}
                              className="obituary-overview-card-icon"
                            />
                            {funeral.falecimentoData}
                          </h4>
                        </Col>
                        <Col
                          md="2"
                          sm="2"
                          xs="4"
                          className="obituary-overview-col"
                        >
                          <h4
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <TbBuildingBank
                              style={{ color: props.iconColor }}
                              className="obituary-overview-card-icon"
                            />
                            {funeral.cemiterioNome}
                          </h4>
                        </Col>
                        <Col sm="2" className="obituary-overview-btn-col">
                          <Button
                            className="primary-btn-obituary-overview"
                            style={{
                              backgroundColor: props.primaryBtnColor,
                              fontFamily: "Monotype-Corsiva-Regular",
                              fontColor: props.white,
                              borderColor: props.primaryBtnColor,
                            }}
                            onClick={() =>
                              setModalShow(true) +
                              setFalecidoName(funeral.falecidoNome)
                            }
                          >
                            Acenda uma vela
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  ""
                ),
              )}
            </div>
          ) : (
            <div className="no-data-container">
              <PiHandsPraying className="no-data-container-icon" /> Sem
              registros no momento
            </div>
          )}
          <Container>
            <CandleModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              centered
              size="lg"
              falecido={falecidoName}
              btncolor={props.primaryBtnColor}
            />
          </Container>
        </Container>
      </Container>
    </Container>
  );
}
